import { getIsTeacher, getMe } from 'platform-components/src/components/user/selectors';
import { createSelector } from 'reselect';

import { PersonalDataModalStore } from 'common.components/personal-data-modal/typings';

const personalDataModalSelector = <T extends { personalDataModal: PersonalDataModalStore }>(storeState: T) =>
    storeState.personalDataModal;

export const getShouldShowPersonalDataModal = createSelector([getMe, getIsTeacher], (me, isTeacher) => {
    return isTeacher && (!me?.is_personal_data_accepted || !me?.is_tos_accepted);
});

export const getWasPersonalDataModalShown = createSelector([personalDataModalSelector], (state) => state.wasShown);
